import { Injectable } from '@angular/core';
import { ExtendedServerErrorResponse, LoggingService } from '@app-core';
import { BaseErrorHandlerModel } from '../../interface/error-handler.interface';

@Injectable({
    providedIn: 'root',
})
export class BadRequestErrorHandlerService extends BaseErrorHandlerModel {
    override handle(error: ExtendedServerErrorResponse): void {
        LoggingService.log('BadRequestErrorHandlerService::handle:', error);
        let errorMessage = error.error.message ?? `Error Code: ${error.status}\nMessage: ${error.message}`;
        let alertHeading = 'An error has occurred';

        // Ensure error.error is an object before checking for 'context'
        if (error.error && typeof error.error === 'object' && 'context' in error.error && error.error.context) {
            alertHeading = error.error.context as string;
        }

        // If the errors object has contents, append them to the error message
        if (error.error && typeof error.error === 'object' && error.error.errors && Object.keys(error.error.errors).length > 0) {
            errorMessage = Object.entries(error.error.errors)
                .map(([key, value]) => `${value}`)
                .join('<br />');
        }

        this.alertService.error(errorMessage, { heading: alertHeading, keepAfterRouteChange: false });
    }
}
